import { CardImage, Pricing } from '.';
import { cn } from '@/utils/cn';
import { GoodbyeSummerLandingCardProps } from './types';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
export const GoodbyeSummerLandingCard = ({
  pricingProps,
  brand,
  name,
  image,
  isLazy,
  isSalable,
  className = ''
}: GoodbyeSummerLandingCardProps) => {
  const {
    isMobile
  } = useMobileDetect();
  const imageSize = isMobile ? 126 : 234;
  const hasDiscount = !!pricingProps.discountPercent;
  return <div className={cn('relative flex h-full w-full cursor-default flex-col gap-2 rounded-md border border-border-gray-light bg-surface-solid-0 p-1.5 shadow-none lg:rounded-lg', className)} data-sentry-component="GoodbyeSummerLandingCard" data-sentry-source-file="goodbye-summer-landing-card.tsx">
            {hasDiscount && <span className='absolute left-2 top-2 z-[1] flex h-6 animate-pulse-discount items-center justify-center rounded-md bg-red-600 px-1.5 text-body-14 font-medium text-text-white lg:h-7 lg:text-base'>
                    {pricingProps.discountPercent}٪
                </span>}
            <div className='flex grow flex-col gap-1'>
                <CardImage alt={name} image={image} srcSet={{
        desktop: 234,
        mobile: 126
      }} isLazy={isLazy} imageClassName={cn('aspect-square', 'w-32 lg:w-56 h-32 lg:h-56')} width={imageSize} height={imageSize} data-sentry-element="CardImage" data-sentry-source-file="goodbye-summer-landing-card.tsx" />

                <span className='text-caption-10 text-text-darkGray lg:text-caption-12'>{brand}</span>

                <h3 className='line-clamp-2 text-caption-12 text-text-black lg:text-base lg:font-medium'>{name}</h3>
            </div>
            {isSalable ? <Pricing {...pricingProps} isLanding isGoodbyeSummerLanding /> : <span className='mr-auto pt-5 text-caption-12 font-medium text-text-black lg:px-5 lg:pt-6 lg:text-body-14'>
                    تمام شد
                </span>}
        </div>;
};